var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TPText',{staticClass:"scrollable-div",style:({ height: _vm.textHeight + 'px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }